import { render, staticRenderFns } from "./ProductRegistration.vue?vue&type=template&id=06c11b02&scoped=true&"
import script from "./ProductRegistration.vue?vue&type=script&lang=ts&"
export * from "./ProductRegistration.vue?vue&type=script&lang=ts&"
import style0 from "./ProductRegistration.vue?vue&type=style&index=0&id=06c11b02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c11b02",
  null
  
)

export default component.exports